import React from 'react';
import {reloadIfNewRevision} from 'helpers/appRevision';

// 新しいバージョンがリリースされていたら、詳細を開いたタイミングでページを読み込み直す(#17214)
const useReloadOnNewVersion = (id: string) => {
  React.useEffect(() => {
    reloadIfNewRevision(id);
  }, [id]);
};

export default useReloadOnNewVersion;
